/* eslint-disable @typescript-eslint/naming-convention */
import { SubsectionItem, EPrimaryItemType } from "@similarweb/ui-components";

import { isLocked } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { sidebarTrackingDispatcher } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteNavBarUtils";
import { translate } from "app/filters/i18nFilter";
import { ACTIVATION_ROOT_ROUTE, ACTIVATION_HOME_ROUTE } from "app/pages/activation/routing/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";

import { POSITION_FOR_TRACKING, DEFAULT_TRACKING_PARAMS } from "./constants";

type ActivationItemSchema = { isOpen: boolean };

const ActivationItem = ({ isOpen }: ActivationItemSchema) => {
    const name = proNavigator.current()?.name;
    const isSelected = name.includes(ACTIVATION_ROOT_ROUTE);

    const onClick = async () => {
        sidebarTrackingDispatcher({
            ...DEFAULT_TRACKING_PARAMS,
            report_domain: EPrimarySideBar3StateType.Activation,
            analytics_domain: EPrimarySideBar3StateType.Activation,
            position_order: POSITION_FOR_TRACKING,
            is_locked: isLocked(swSettings.components?.Activation),
        });

        return proNavigator.go(ACTIVATION_HOME_ROUTE);
    };

    return (
        <SubsectionItem
            isSelected={isSelected}
            key="activation-menu-item"
            itemText={translate("activation.sidebar.title")}
            icon="homepage"
            itemType={EPrimaryItemType.StandalonePrimary}
            isCollapsed={!isOpen}
            onItemClick={onClick}
        />
    );
};

export default ActivationItem;
